import { QUESTION_COUNT } from "../../../../types/Config";
import { EnumEventBus, eventBus } from "../../../EventBus";


export default function setQuestionTypes(currQuestion: number) {
  const getActiveQuestionTypes = (isFirst: boolean) => ({ TYPE1: isFirst, TYPE2: !isFirst })

  if (currQuestion == 0) {
    eventBus.emit(EnumEventBus.setActiveQuestionType, getActiveQuestionTypes(true))
  } else if (currQuestion == QUESTION_COUNT / 2) {
    eventBus.emit(EnumEventBus.setActiveQuestionType, getActiveQuestionTypes(false))
  }
}
